import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`mx-auto w-full max-w-6xl p-6`}
`;

const StatusPickerSkeleton = styled.div`
  ${tw`w-full flex overflow-x-auto pb-2 space-x-2 md:justify-center mb-6`}
`;

const TabSkeleton = styled(Skeleton)`
  ${tw`flex-shrink-0 rounded-full`}
  width: 100px;
  height: 36px;
`;

const CardGridSkeleton = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6`}
`;

const CardSkeleton = styled.div`
  ${tw`bg-white rounded-card border border-border-default p-5 flex flex-col space-y-4`}
`;

const PaginationSkeleton = styled.div`
  ${tw`flex justify-between items-center mt-8`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`w-32 h-10 rounded-full`}
`;

const PageInfoSkeleton = styled(Skeleton)`
  ${tw`w-16 h-4`}
`;

const InvoicesListSkeleton: React.FC = () => {
  return (
    <Container>
      <StatusPickerSkeleton>
        {Array(6)
          .fill(0)
          .map((_, i) => (
            <TabSkeleton key={i} />
          ))}
      </StatusPickerSkeleton>

      <CardGridSkeleton>
        {Array(6)
          .fill(0)
          .map((_, i) => (
            <CardSkeleton key={i}>
              <div tw="flex justify-between items-start">
                <Skeleton width="80px" height="24px" />
                <Skeleton width="100px" height="24px" borderRadius="12px" />
              </div>
              <div tw="space-y-4">
                <div tw="grid grid-cols-2 gap-4">
                  <Skeleton width="100%" height="28px" />
                  <Skeleton width="100%" height="28px" />
                </div>
                <Skeleton width="60%" height="24px" />
                <Skeleton width="80%" height="24px" />
              </div>
              <div tw="mt-4 pt-4 border-t border-gray-50 flex justify-between items-center">
                <Skeleton width="70px" height="32px" />
                <Skeleton width="80px" height="20px" />
              </div>
            </CardSkeleton>
          ))}
      </CardGridSkeleton>

      <PaginationSkeleton>
        <ButtonSkeleton />
        <PageInfoSkeleton />
        <ButtonSkeleton />
      </PaginationSkeleton>
    </Container>
  );
};

export default InvoicesListSkeleton;
